export default __webpack_public_path__ + "images/ca0d5675d9c6a56bc66b1bb95dd8c597-healthcare.webp";